import React from 'react';
import { Link, Button } from '@mui/material';

export const FindAVenueButton = () => {
  return (
    <Button
      component={Link}
      href="https://www.perfectvenue.com/concierge"
      target="_blank"
      sx={{ color: 'text.primary' }}
    >
      Get Recommendations
    </Button>
  );
};
